/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" _fill="#333" d="M512 63.2c-246.9 0-447 201.4-447 449.7s200.1 449.7 447 449.7 447-201.3 447-449.7S758.9 63.2 512 63.2zm222.5 635.5c10.2 10.3 10.2 27.2 0 37.5l-7.9 8c-10.3 10.3-27.1 10.3-37.3 0L510.1 564 330.9 744.2c-10.3 10.3-27.1 10.3-37.3 0l-7.9-8c-10.3-10.3-10.3-27.2 0-37.5l179.1-180.2-179.1-180.3c-10.3-10.3-10.3-27.2 0-37.5l7.9-8c10.3-10.3 27.1-10.3 37.3 0L510.1 473l179.2-180.3c10.2-10.3 27-10.3 37.3 0l7.9 8c10.2 10.3 10.2 27.2 0 37.5L555.3 518.5l179.2 180.2z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/close.js